<script>
import { EventBus } from '@/helpers/eventBus'
export default {
  props: {
    user: {
      type: Object
    },
    role: {
      type: String
    },
    credential: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {
      dialog: false,
      notification: {
        state: true,
        message: '',
        type: 'success'
      },
      loading: false
    }
  },
  computed: {
    payload() {
      let payload = {}
      if (this.user) {
        payload = {
          userId: this.user.id,
          roleName: this.credential.name
        }
      }
      if (this.role) {
        payload = {
          roleName: this.role,
          permission: this.credential.name
        }
      }
      return payload
    },
    functionName() {
      let userRoleFuncName = this.credential.checked
        ? 'removeRoleFromUser'
        : 'addRoleToUser'
      let permissionsfuncName = this.credential.checked
        ? 'removePermissionFromRole'
        : 'addPermissionToRole'
      return this.user ? userRoleFuncName : permissionsfuncName
    }
  },
  created(){

  },
  methods: {
    async toggleCredential() {
      this.loading = true
      let action = this.credential.checked
        ? this.$t('component.backoffice.removed')
        : this.$t('component.backoffice.added')
      try {
        await this.$backofficeService[this.functionName](this.payload)
        this.$emit('change')
        this.notification.message = this.$t("component.backoffice.success", { action })
        this.notification.type = "success"
      } catch {
        this.notification.message = this.$t("component.backoffice.error", { action })
        this.notification.type = "error"
      } finally {
        this.notification.state = true
        EventBus.$emit("backoffice_notification", this.notification)
        this.dialog = false
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <template #activator="{ on }">
      <v-checkbox
        :input-value="credential.checked"
        class="ma-0 pa-0"
        :disabled="disabled"
        hide-details
        v-on="on"
        @click.stop.prevent="dialog = true"
      />
    </template>
    <v-card>
      <DialogBaseColoredTitle color="primary">
        {{ $t("component.backoffice.change") }}
      </DialogBaseColoredTitle>
      <v-divider></v-divider>
      <DialogBaseText
        v-html="$t('component.backoffice.confirm',{
        role: credential.name,
        action: $t(`component.backoffice.${credential.checked ? 'remove' : 'add'}`)
      })">
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions>
        <v-btn color="secondary" @click="dialog = false">{{ $t("button.cancel") }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          :color="credential.checked ? 'error' : 'success'"
          @click="toggleCredential"
        >
          {{ $t(`component.backoffice.${credential.checked ? 'Remove' : 'Add'}`) }}
        </v-btn>
      </DialogBaseActions>
    </v-card>
  </v-dialog>
</template>
